export interface MarkerType {
  size: [number, number];
  anchor: [number, number];
  name: string;
  type: Type;
}

export enum Type {
  STANDARD, IMAGE
}
